import { render, staticRenderFns } from "./CommonUserProjectTree.vue?vue&type=template&id=5f53fefd&scoped=true&"
import script from "./CommonUserProjectTree.vue?vue&type=script&lang=js&"
export * from "./CommonUserProjectTree.vue?vue&type=script&lang=js&"
import style0 from "./CommonUserProjectTree.vue?vue&type=style&index=0&id=5f53fefd&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f53fefd",
  null
  
)

export default component.exports